function init(elements) {
    const $elements = $('[data-tabs-button]');

    $elements.on('click', function () {
        const $this = $(this);
        const ns = $this.data('tabs-ns');
        const key = $this.data('tabs-button');

        const $buttons = $(`[data-tabs-ns="${ns}"][data-tabs-button]`);
        const $blocks = $(`[data-tabs-ns="${ns}"][data-tabs-block]`);

        const $buttonsOther = $buttons.filter(`:not([data-tabs-button="${key}"])`);
        const $blocksOther = $blocks.filter(`:not([data-tabs-block="${key}"])`);
        const $buttonsCurrent = $buttons.filter(`[data-tabs-button="${key}"]`);
        const $blocksCurrent = $blocks.filter(`[data-tabs-block="${key}"]`);

        $buttonsOther.removeClass('is-active');
        $blocksOther.removeClass('is-active');
        $buttonsCurrent.addClass('is-active');
        $blocksCurrent.addClass('is-active');
    });
}

export default function (elements) {
    init(elements);
}